import {datadogRum} from '@datadog/browser-rum';

const BASE_DATADOG_ACTIONS = {
  DOWNLOAD: 'DOWNLOAD',
};

function addDatadogAction(actionName, params) {
  datadogRum.addAction(actionName, params);
}

//Reports a problem to datadog
export function addDatadogError(error, context) {
  datadogRum.addError(error, context);
}

export function datadogDownloadAction(params) {
  addDatadogAction(BASE_DATADOG_ACTIONS.DOWNLOAD, params);
}

//Use to report an error to datadog when a JSON.parse fails
export function datadogJsonParseError(error, locationUuid) {
  addDatadogError(error, {details: 'An error occured while calling JSON.parse', location: locationUuid});
}
